





























































































import {
    Component, Model, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { DELETE_TEMPLATE, RENAME_TEMPLATE } from '@/store/modules/template';
import { cloneDeep, findIndex, map } from 'lodash';
import CustomDialog from '@/components/global/CustomDialog.vue';
import InsertPhotoDialogPhotos from '@/components/global/InsertPhotoDialog/InsertPhotoDialogPhotos.vue';
import InsertPhotoDialogUpload from '@/components/global/InsertPhotoDialog/InsertPhotoDialogUpload.vue';
import { ProductTemplate } from '@/assets/interface/Product';
import SimpleDialog from '@/components/global/SimpleDialog.vue';
import Tabs from '@/components/global/Tabs.vue';
// import InsertPhotoDialogUrl from '@/components/global/InsertPhotoDialog/InsertPhotoDialogUrl.vue';
import index from '@/store';

@Component({
    components: {
        CustomDialog,
        SimpleDialog,
        Tabs,
        InsertPhotoDialogUpload,
        InsertPhotoDialogPhotos,
        // InsertPhotoDialogUrl,
    },
})
export default class InsertPhotoDialog extends Vue {
    @Model('update:returnValue', { type: Boolean }) readonly value!: boolean;

    public photos: string[] = [];

    public urlImage = '';

    public tab: any = null;

    public tabItems = [
        {
            name: 'Photos',
        },
        {
            name: 'Upload',
        },
        // {
        //     name: 'Web Address (URL)',
        // },
    ];

    public onUploadFinish(files: any) {
        const urls = map(files, (file: any) => file.url);
        this.$emit('insert', urls);
        this.emitReturnValue(false);
    }

    public emitReturnValue(event: any) {
        this.$emit('update:returnValue', event);
    }

    public onInsertClick() {
        switch (this.tab) {
                case 0:
                // photos
                    this.$emit('insert', this.photos);
                    this.reset();
                    break;
                case 2:
                    this.$emit('insert', this.urlImage);
                    this.reset();
                    // url
                    break;
                default:
                // do nothing
                    break;
        }
    }

    public onCancelClick() {
        this.reset();
    }

    public reset() {
        this.photos = [];
        this.urlImage = '';
        this.emitReturnValue(false);
    }

    get insertButtonDisabled() {
        switch (this.tab) {
                case 0:
                // photos
                    return !((this.photos.length > 0));
                case 1:
                // upload
                    return true;
                case 2:
                // url
                    return this.urlImage.length === 0;
                default:
                    return true;
        }
    }
}
